import { useControlledSwr as e } from "./use-controlled-swr.mjs";
import { useTimeout as t } from "./use-timeout.mjs";
//#region src/hooks/use-status-polling.ts
var n = (n, r, { isPending: i, intervalMs: a = 1500, errorRetryCount: o = 3, timeoutMs: s }, c = !0) => {
	let l = t(s, c), u = e(n, r, {
		refreshInterval(e) {
			return i(e) && !l ? a : 0;
		},
		errorRetryCount: o
	}, c);
	return {
		...u,
		timedOut: l && i(u.data)
	};
};
//#endregion
export { n as useStatusPolling };
